import { IFarmer } from "../farmerProfile/farmerProfile";
import { IBlog } from "../recentBlog/recentBlog";
interface IBlogCard extends IBlog {
  farmer: IFarmer;
}

function farmerBlogListHTMLTemplate(list: IBlog[]) {
  return list.reduce(
    (acc, current) =>
      acc +
      `<li class="container-card-list-item">
            <a href="${current.path}">
              <div
                class="container-card-list-item-cover grid place-content-center"
              >
                <picture>
                  <source
                    srcset="${current.coverTablet}"
                    media="(max-width: 768px)"
                  />
                  <img
                    src="${current.coverComputer}"
                    alt="${current.coverDescription}"
                    loading="lazy"
                  />
                </picture>
              </div>
              <h2
                class="container-card-list-item-title text-sm lg:text-2xl mt-2 lg:mt-4 line-clamp-3 lg:line-clamp-2"
              >
                ${current.title}
              </h2>
              <div
                class="container-card-list-item-date-gray text-2xs lg:text-sm mt-auto pt-2 lg:pt-4"
              >
                ${current.publishedDate}
              </div>
            </a>
          </li>`,
    ""
  );
}

function blogListHtmlTemplate(list: IBlogCard[]) {
  return list.reduce(
    (acc, current) =>
      acc +
      `<li class="container-card-list-item">
          <a href="${current.path}">
            <div
              class="container-card-list-item-cover grid place-content-center"
            >
              <picture>
                <source
                  srcset="${current.coverTablet}"
                  media="(max-width: 768px)"
                />
                <img
                  src="${current.coverComputer}"
                  alt="${current.coverDescription}"
                  loading="lazy"
                />
              </picture>
            </div>
            <h2 class="container-card-list-item-title text-sm lg:text-2xl mt-4 line-clamp-3 lg:line-clamp-2">
              ${current.title}
            </h2>
            <div class="container-card-list-item-date pt-1 pb-3 lg:py-4 mt-auto">
              ${current.publishedDate}
            </div>
            <div class="flex">
              <div
                data-farmer-username="${current.farmer.username}"
                class="container-card-list-item-author rounded-full flex items-center"
              >
                <div
                  class="w-3 h-3 lg:w-8 lg:h-8 grid place-content-center rounded-full overflow-hidden mr-1 lg:mr-2.5"
                >
                  <img
                    src="${current.farmer?.avatar}"
                    alt="${current.farmer?.name}"
                    loading="lazy"
                  />
                </div>
  
                <span
                  class="truncate max-w-14 mr-1 lg:max-w-28 lg:mr-2"
                >
                  ${current.farmer?.name}</span
                >
  
                <span
                  class="container-card-list-item-author-title truncate max-w-14 pl-1 lg:max-w-28 lg:pl-2"
                >
                  ${current.farmer?.farmName}
                </span>
              </div>
            </div>
          </a>
        </li>
    `,
    ""
  );
}

function farmerListHtmlTemplate(list: IFarmer[]) {
  return list.reduce(
    (acc, current) =>
      acc +
      ` <li class="container-farmer-list-item">
              <a href="/farmers/${current.username}">
                <img
                  class="container-farmer-list-item-ava"
                  src="${current.avatar}"
                  alt="${current.avatarDescription}"
                />
                <p class="truncate container-farmer-list-item-name">
                  ${current.name}
                </p>
                <p class="truncate container-farmer-list-item-title">
                  ${current.farmName}
                </p>
                <p class="truncate container-farmer-list-item-company">
                  ${current.prefecture}
                </p>
              </a>
            </li>`,
    ""
  );
}

export const LIST_TYPE = {
  "farmer-blog-list": {
    api: "/farmer",
    htmlTemplate: farmerBlogListHTMLTemplate,
  },
  "blog-list": {
    api: "/blogs.json",
    htmlTemplate: blogListHtmlTemplate,
  },
  "farmer-list": {
    api: "/farmers.json",
    htmlTemplate: farmerListHtmlTemplate,
  },
};
